module.exports = __webpack_public_path__ + "img/flow-icon-1.7a4191cf.png";